import React, { useMemo } from 'react';

import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { getEarningsInsightWithEventByEarningsId } from '~/react-query-hooks/events/use-event-feed/earnings-from-events';
import { useEventFeed } from '~/react-query-hooks/events/use-event-feed/useEventFeed';
import { queryKeys } from '~/routes/query-params';
import { POSTHOG_TRACKING_SOURCES } from '~/services/tracking/posthog/constants';
import { useSubscription } from '~/stores/use-subscription/useSubscription';
import { EarningsInsightIcon } from '~/widgets/earnings-insight-drawer/earnings-insight-widget/components/earnings-insight-icon/EarningsInsightIcon';

import { DateCell, DateCellProps } from './DateCell';
import * as S from './DateCellWithEarningsInsight.styles';

export const DateCellWithEarningsInsight = ({
  earningsId,
  ...rest
}: DateCellProps & { earningsId: string }) => {
  const isBasicOrLightUser = useSubscription(state =>
    state.isBasicOrLightUser()
  );
  const { params } = useQueryParams();
  const entityTag = params[queryKeys.assetOverviewAsset];

  const { data: eventFeedData } = useEventFeed(
    {
      entities: entityTag ? [entityTag] : [],
      type: 'earnings-insight',
    },
    {
      enabled: !isBasicOrLightUser && !!earningsId && !!entityTag,
    }
  );
  const earningsInsightWithEvent = useMemo(() => {
    if (!earningsId) return undefined;
    const events = eventFeedData?.pages?.flatMap(page => page.events) ?? [];
    return getEarningsInsightWithEventByEarningsId(events, earningsId);
  }, [earningsId, eventFeedData?.pages]);

  return (
    <S.Root>
      <DateCell {...rest} />
      {!!earningsInsightWithEvent && entityTag && (
        <EarningsInsightIcon
          entityTag={entityTag}
          size={28}
          earningsInsight={earningsInsightWithEvent.earningsInsight}
          eventId={earningsInsightWithEvent.eventId}
          read={earningsInsightWithEvent.read}
          source={POSTHOG_TRACKING_SOURCES.ASSET_OVERVIEW}
        />
      )}
    </S.Root>
  );
};
